import { createAction, props } from '@ngrx/store';
import { InformationPopupPage } from '../../shared/components/information-popup/information-popup.model';
import { UserPageSettings } from './information-popup.state';

export namespace InformationPopupActions {
  export enum Type {
    LOAD_SETTINGS = '[INFORMATION POPUP] Load Settings',
    LOAD_SETTINGS_SUCCESS = '[INFORMATION POPUP] Load Settings Success',
    LOAD_SETTINGS_ERROR = '[INFORMATION POPUP] Load Settings Error',
    SET_PAGE_SETTINGS = '[INFORMATION POPUP] Set Page Settings',
    SAVE_PAGE_SETTINGS = '[INFORMATION POPUP] Save Page Settings',
    SAVE_PAGE_SETTINGS_SUCCESS = '[INFORMATION POPUP] Save Page Settings Success',
    SAVE_PAGE_SETTINGS_ERROR = '[INFORMATION POPUP] Save Page Settings Error',
  }

  export const loadSettings = createAction(Type.LOAD_SETTINGS);
  export const loadSettingsSuccess = createAction(
    Type.LOAD_SETTINGS_SUCCESS,
    props<{ settings: UserPageSettings[] }>()
  );
  export const loadSettingsError = createAction(Type.LOAD_SETTINGS_ERROR, props<{ error: any }>());
  export const setPageSettings = createAction(
    Type.SET_PAGE_SETTINGS,
    props<{ page: InformationPopupPage }>()
  );
  export const savePageSettings = createAction(Type.SAVE_PAGE_SETTINGS);
  export const savePageSettingsSuccess = createAction(Type.SAVE_PAGE_SETTINGS_SUCCESS);
  export const savePageSettingsError = createAction(
    Type.SAVE_PAGE_SETTINGS_ERROR,
    props<{ error: any }>()
  );
}
